import React from 'react';
import { Sales, ViewConfig } from '../types';
import { AccountIndicatorsBlock } from '../ui/informationBlocks/AccountIndicatorsBlock';
import { AccountIndicatorsLine } from '../ui/informationBlocks/AccountIndicatorsLine';
import { useTranslation } from '../../../../../hooks';

export const renderIndicators = (
  config: ViewConfig,
  todaySales: Sales,
) =>{
  const {t} = useTranslation()
  return (
    <>
      {config.main &&
        config.main.map((indicator, idx) =>{
          return (
            <AccountIndicatorsBlock
              key={idx}
              label={t(indicator.label)}
              value={todaySales[indicator.key]}
              format={indicator.format}
              suffix={indicator.suffix}
              lonelyBlock
            />
          );
        })}
      {config.lines &&
        config.lines.map((line, lineIdx) => (
          <AccountIndicatorsLine key={`line-${lineIdx}`} items={line.items} sales={todaySales} />
        ))}
    </>
  );
};
